// Theme configurations for child portal
export const childThemes = {
  purple: {
    name: 'Purple Dream',
    primary: 'from-purple-600 to-pink-600',
    primaryHover: 'from-purple-700 to-pink-700',
    headerBg: 'from-purple-600 to-pink-600',
    cardBg: 'from-purple-50 via-pink-50 to-blue-50',
    accentColor: 'purple-600',
    secondaryColor: 'pink-600',
    buttonPrimary: 'from-purple-600 to-pink-600',
    buttonSecondary: 'from-pink-500 to-orange-500',
    loginBg: 'from-purple-100 via-pink-100 to-blue-100',
    iconColor: 'text-purple-600'
  },
  blue: {
    name: 'Ocean Adventure',
    primary: 'from-blue-600 to-teal-600',
    primaryHover: 'from-blue-700 to-teal-700',
    headerBg: 'from-blue-600 to-teal-600',
    cardBg: 'from-blue-50 via-teal-50 to-green-50',
    accentColor: 'blue-600',
    secondaryColor: 'teal-600',
    buttonPrimary: 'from-blue-600 to-teal-600',
    buttonSecondary: 'from-teal-500 to-green-500',
    loginBg: 'from-blue-100 via-teal-100 to-green-100',
    iconColor: 'text-blue-600'
  }
};

export const getChildTheme = (themeName) => {
  return childThemes[themeName] || childThemes.purple;
};
